import React from "react";
import Modal from "./modal";

const ConfirmDeletePlaylistModal = ({ isOpen, onClose, onConfirm, playlistTitle }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc={false}
    >
      <div className="content">
        <div className="confirm-delete-message">
          Are you sure you want to delete{" "}
          <strong>{playlistTitle}</strong>?
        </div>
        <div className="buttons-wrapper">
          <div className="button button--back" onClick={onClose}>
            CANCEL
          </div>
          <div className="button button--continue button--delete" onClick={onConfirm}>
            DELETE
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeletePlaylistModal;
